import { render, staticRenderFns } from "./IntegrationTemplateSetup.vue?vue&type=template&id=c0878dec"
import script from "./IntegrationTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./IntegrationTemplateSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports